// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__yVMeB","SideDrawerNav":"SideDrawer_SideDrawerNav__VT205","Logo":"SideDrawer_Logo__D7Vq7"};